import { useEffect, useState } from 'react';

/**
 * Retorna uma versão "atrasada" de `value`, atualizada apenas após `delay` ms
 * sem mudanças. Útil para busca server-side: evita uma request por tecla.
 */
export function useDebouncedValue<T>(value: T, delay = 350): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
}
